import {Component, model, output, ChangeDetectionStrategy} from "@angular/core"
import {FormsModule} from "@angular/forms"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-checkbox",
    templateUrl: "./checkbox.component.html",
    styleUrls: ["./checkbox.component.scss"],
    imports: [FormsModule],
})
export class CheckboxComponent {
    readonly $value = model.required<boolean>({alias: "value"})
    readonly valueChange = output<boolean>() // Explicit output for compatibility

    onValueChange() {
        this.valueChange.emit(this.$value())
    }
}
